// src/components/home/TrustStats.jsx
import React from "react";
import {
  Users,
  Car,
  MapPin,
  Headphones,
  ShieldCheck,
  ArrowUpRight,
} from "lucide-react";

const stats = [
  {
    icon: Users,
    value: "Trusted",
    label: "by Our Customers",
    description: "Reliable service",
  },
  {
    icon: Car,
    value: "Wide Range",
    label: "of Vehicles",
    description: "Comfort for every journey",
  },
  {
    icon: MapPin,
    value: "Multiple",
    label: "Destinations",
    description: "Local & outstation travel",
  },
  {
    icon: Headphones,
    value: "24/7",
    label: "Support",
    description: "We're here when you need us",
  },
];

const TrustStats = () => {
  return (
    <section className="relative mx-auto max-w-7xl overflow-hidden px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
      {/* Background decoration */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#00A260]/5 blur-3xl"
      />

      <div className="relative">
        {/* Section heading */}
        <div className="mx-auto mb-8 max-w-2xl text-center sm:mb-10">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-[#00A260]/15 bg-[#00A260]/5 px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-[#00A260]">
            <ShieldCheck className="h-3.5 w-3.5" />
            Why Choose NJV
          </div>

          <h2 className="text-2xl font-extrabold tracking-tight text-[#061A3A] sm:text-3xl lg:text-4xl">
            Travel with confidence
          </h2>

          <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-[#475569] sm:text-base">
            Comfortable vehicles, dependable service and support throughout
            your journey.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4">
          {stats.map(
            ({ icon: Icon, value, label, description }, index) => (
              <div
                key={label}
                className="group relative overflow-hidden rounded-2xl border border-[#E2E8E5] bg-white p-4 shadow-sm transition-all duration-500 hover:-translate-y-1 hover:border-[#00A260]/30 hover:shadow-xl sm:rounded-3xl sm:p-6"
                style={{
                  animationDelay: `${index * 100}ms`,
                }}
              >
                {/* Hover glow */}
                <div className="absolute -right-8 -top-8 h-20 w-20 rounded-full bg-[#00A260]/5 transition-transform duration-500 group-hover:scale-[2.5]" />

                <div className="relative">
                  {/* Icon */}
                  <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-[#00A260]/10 text-[#00A260] transition-all duration-300 group-hover:scale-110 group-hover:bg-[#00A260] group-hover:text-white sm:h-12 sm:w-12 sm:rounded-2xl">
                    <Icon className="h-5 w-5 sm:h-6 sm:w-6" />
                  </div>

                  {/* Value */}
                  <div className="flex items-center justify-between gap-2">
                    <p className="text-lg font-extrabold leading-tight text-[#061A3A] sm:text-xl">
                      {value}
                    </p>

                    <ArrowUpRight className="h-4 w-4 text-[#CBD5D1] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#00A260]" />
                  </div>

                  {/* Label */}
                  <p className="mt-1 text-xs font-semibold leading-5 text-[#475569] sm:text-sm">
                    {label}
                  </p>

                  {/* Description */}
                  <p className="mt-2 hidden text-xs leading-5 text-[#94A3B8] sm:block">
                    {description}
                  </p>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default TrustStats;